import cn from 'classnames';
import React from 'react';

export enum GradientCardType {
  default = 'default',
  error = 'error',
  success = 'success',
}

export type GradientCardProps = {
  gradientType?: GradientCardType;
  headerText: string;
  text: string;
};

// @visible-for-testing
export const GradientCardTypeMap = {
  [GradientCardType.default]: 'odin-bg-odin-gradient-2',
  [GradientCardType.error]: 'odin-bg-odin-gradient-error',
  [GradientCardType.success]: 'odin-bg-odin-gradient-success',
};

export function GradientCard({
  headerText,
  text,
  gradientType = GradientCardType.default,
}: GradientCardProps): React.ReactElement {
  return (
    <div
      className={cn(
        'odin-p-6 odin-rounded-xl odin-text-white odin-text-center',
        GradientCardTypeMap[gradientType],
      )}
      data-testid="gradient-card-container"
    >
      <h2
        className="odin-mb-2 odin-text-1.5xl odin-font-medium"
        data-testid="gradient-card-header"
      >
        {headerText}
      </h2>
      <div className="odin-text-sm" data-testid="gradient-card-body">
        {text}
      </div>
    </div>
  );
}
